import { Image, Skeleton } from '@chakra-ui/react';
import { memo } from 'react';
import { areEqual } from 'react-window';
import { isTest } from 'utils/environment';

import { THUMBNAIL_HEIGHT, THUMBNAIL_WIDTH } from '../InfiniteGrid/InfiniteGrid.config';
import { UserImageProps } from './UploadMenu.helper';

export const UserImage = memo(({ idx, url, imageRef, ignoreFallback, id, imageProps }: UserImageProps) => {
  return (
    <Image
      id={id}
      key={idx}
      ref={imageRef}
      objectFit='contain'
      width='auto'
      height={THUMBNAIL_HEIGHT}
      src={url}
      role='presentation'
      // need to set pointer events to none here as drag event is triggered for image / svg elements within the draggable container
      pointerEvents='none'
      alt=''
      // pointer events is set in the skeleton for same reason as above
      fallback={<Skeleton width={THUMBNAIL_WIDTH} height={THUMBNAIL_HEIGHT} pointerEvents='none' />}
      // skip loading images in test environment since the fallback can't be mocked
      ignoreFallback={ignoreFallback ?? isTest}
      {...imageProps}
    />
  );
}, areEqual);
UserImage.displayName = 'UserImage';
